import {
  LOCAL_TOKEN,
  isModeInModuleBySlug,
  isModuleBySlug,
  LOCAL_TWO_FACTOR_AUTH_PENDING,
} from "../../utils/storage"
import { Redirect, Route } from "react-router-dom"

import { DISABLE } from "../../utils/constants"
import Layout from "components/Layout"
import PropTypes from "prop-types"
import React from "react"
import { validate } from "../../utils/functions"
import GenericNotFound from "../GenericNotFound"
import useFreshchatDarkMode from "../../hooks/useFreshchatDarkMode"

// import { createBrowserHistory } from 'history';
const PrivateRouteAccess = ({ component: Component, ...rest }) => {
  useFreshchatDarkMode();

  if (!(LOCAL_TOKEN() || LOCAL_TWO_FACTOR_AUTH_PENDING())) {
    return (
        <Route
            {...rest}
            render={(props) =>
                (
                    <Redirect
                        to={{
                            pathname: rest.redirectPath || "/login",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
}

  let validateRoles = true
  let validateSlug = true
  if (validate.exist(rest.access)) {
    validateRoles = validRole(rest.access)
  }
  if (validate.exist(rest.slug)) {
    if (rest.validateMode) {
      validateSlug = isModeInModuleBySlug(rest.slug) !== DISABLE
    } else {
      validateSlug = isModuleBySlug(rest.slug)
    }
  }



  if (
    !(validateRoles && validateSlug && LOCAL_TOKEN()) &&
    !LOCAL_TWO_FACTOR_AUTH_PENDING()
  )
    localStorage.clear()
    /* if (typeof window.Intercom !== "undefined" && window.self === window.top) {
      document.body.classList.add("has-freshchat")
    } */
  return (
    <Route
      {...rest}
      render={(props) =>
        {
          if(!validateRoles) {
            return <GenericNotFound />
          }
          return (validateRoles && validateSlug && LOCAL_TOKEN()) ||
            LOCAL_TWO_FACTOR_AUTH_PENDING() ? (
              <Layout>
                <Component {...props} />
              </Layout>
            ) : (
              <Redirect
                to={{
                  pathname: rest.redirectPath || "/login",
                  state: { from: props.location },
                }}
              />
            )
        }
      }
    />
  )
}

PrivateRouteAccess.propTypes = {
  validateMode: PropTypes.bool,
}

export default PrivateRouteAccess
